import { updatesData } from '@/mocks/homeData';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm">实时滚动更新，吃瓜快人一步</p>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-4 top-0 bottom-0 w-0.5 bg-background-200"></div>

          <div className="flex flex-col gap-6">
            {updatesData.map((item) => (
              <div key={item.id} className="relative">
                <div className="absolute left-[-1.25rem] md:left-[-1.55rem] top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="bg-background-100 rounded-2xl p-4 md:p-5 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors duration-200">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-primary-500 font-bold text-xs whitespace-nowrap">
                      {item.time}
                    </span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span className="text-foreground-400 text-xs whitespace-nowrap">52吃瓜网快讯</span>
                  </div>
                  <h3 className="text-foreground-800 font-bold text-sm mb-1">{item.title}</h3>
                  <p className="text-foreground-500 text-xs leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}